import React, { useEffect, useState, useCallback, useRef } from "react";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BranchDropDown,
  FormInput,
  TrustDropDown,
} from "../../../../components/Component";
import { ImportExportButton } from "../../../../components/button/ActionButton";
import DateRangePicker from "../../../../components/input/date-time/DateRangePicker";
import { GradeTypeDropDownWithoutCarer } from "../../../../components/dropdowns/GradeTypeDropDown";
import Availabilitidata, { availabilitiesListApi, exportAvailabilitiesAPI } from "./AvailabilitiData";
import { getDates, showErrorToast } from "../../../../utils/Functions";
import { Spinner } from "reactstrap";
const Availabilitilist = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingbtn, setLoadingbtn] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState("");
  const [availabilitiesListData, setavailabilitiesListData] = useState([]);
  const [grade, setGrade] = useState();
  const [hospitalData, setHospitalData] = useState();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [hasMoreData, setHasMoreData] = useState(true);
  const scrollContainerRef = useRef(null);
  const itemsPerPage = 100;
  const datesBetween = getDates(startDate, endDate);
  const loadavailabilitiesList = useCallback(
    (page = 1, isLoadMore = false) => {
      if (!startDate || !endDate) return;
      if (isLoadMore) {
        setLoadingMore(true);
      } else {
        setLoading(true);
        setavailabilitiesListData([]);
        setCurrentPage(1);
        setHasMoreData(true);
      }
      let params = {
        pageInfo: {
          pageIndex: page,
          itemsPerPage: itemsPerPage,
        },
        startDate: startDate,
        endDate: endDate,
        clientId: 0,
        trustId: hospitalData?.trust?.id ?? 0,
        gradeId: grade?.id ?? 0,
        branchId: hospitalData?.branch?.id ?? 0,
        search: search,
      };
      availabilitiesListApi(params, (data, error) => {
        if (error === null) {
          if (isLoadMore) {
            // Append new data to existing data
            setavailabilitiesListData((prev) => [...prev, ...data?.list]);
          } else {
            // Replace data for new search/filter
            setavailabilitiesListData(data?.list);
          }
          const newTotalPages = data?.pageInfo?.totalPages || 0;
          const newHasMoreData = page < newTotalPages;
          setTotalPages(newTotalPages);
          setCurrentPage(page);
          setHasMoreData(newHasMoreData);
        } else {
          showErrorToast(error.message);
        }
        if (isLoadMore) {
          setLoadingMore(false);
        } else {
          setLoading(false);
        }
      });
    },
    [startDate, endDate, hospitalData, grade?.id, search],
  );
  const loadMoreData = useCallback(() => {
    if (loadingMore || !hasMoreData || currentPage >= totalPages) return;
    const nextPage = currentPage + 1;
    loadavailabilitiesList(nextPage, true);
  }, [loadingMore, hasMoreData, currentPage, totalPages, loadavailabilitiesList]);

  // Only load data when filters change, not automatically
  useEffect(() => {
    if (!startDate || !endDate) return;
    loadavailabilitiesList();
  }, [startDate, endDate, grade?.id, hospitalData, search, loadavailabilitiesList]);
  const onExportClick = () => {
    if (!startDate || !endDate) return;
    setLoadingbtn(true);
    let params = {
      startDate: startDate,
      endDate: endDate,
      clientId: 0,
      trustId: hospitalData?.trust?.id ?? 0,
      gradeId: grade?.id ?? 0,
      branchId: hospitalData?.branch?.id ?? 0,
    };
    exportAvailabilitiesAPI(params, (data, error) => {
      if (error === null) {
        window.open(data?.fileUrl, "default");
      }
      setLoadingbtn(false);
    });
  };
  const handleDatePickerChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };
  return (
    <React.Fragment>
      <Head title="Availabilities" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <BlockTitle page>Availabilities</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent className="ms-auto">
              <ul className="nk-block-tools g-2 d-flex flex-wrap justify-content-end">
                <li>
                  <FormInput
                    labelGroupClass="m-0"
                    value={search ?? ""}
                    placeholder="Search Carer"
                    onTextChange={(text) => setSearch(text)}
                  />
                </li>
                <li>
                  <TrustDropDown
                    value={hospitalData?.trust}
                    selectedId={hospitalData?.trust?.id}
                    onSelect={(trust) => {
                      setHospitalData((prev) => ({
                        ...prev,
                        trust: trust,
                      }));
                    }}
                    className="w-320px"
                    placeholder={"Select Trust"}
                  />
                </li>
                <li>
                  <BranchDropDown
                    value={hospitalData?.branch}
                    selectedId={hospitalData?.branch?.id}
                    onSelect={(branch) => {
                      setHospitalData((prev) => ({
                        ...prev,
                        branch: branch,
                      }));
                    }}
                    isClearable
                    className="w-225px"
                    placeholder={"Select Area Manager"}
                  />
                </li>
                <li>
                  <GradeTypeDropDownWithoutCarer
                    value={grade}
                    isClearable
                    isShowAll
                    className="w-225px"
                    placeholder="Grade Type"
                    onSelect={(selectedGrade) => {
                      setGrade(selectedGrade);
                    }}
                  />
                </li>
                <li>
                  <DateRangePicker onDateChange={handleDatePickerChange} />
                </li>
                {availabilitiesListData?.length > 0 && (
                  <li>
                    <ImportExportButton
                      title="Export"
                      iconName="arrow-up"
                      loading={loadingbtn}
                      onClick={onExportClick}
                    />
                  </li>
                )}
              </ul>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div ref={scrollContainerRef}>
            <Availabilitidata
              hList={datesBetween}
              vList={availabilitiesListData}
              onLoadMore={loadMoreData}
              hasMoreData={hasMoreData}
              loadingMore={loadingMore}
              scrollContainerRef={scrollContainerRef}
            />
          </div>
        </Block>
        {loading && (
          <div className="table-loader">
            <Spinner className="spinner-border-md" color="primary" />
          </div>
        )}
      </Content>
    </React.Fragment>
  );
};
export default Availabilitilist;
